import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Link, useLocation } from 'react-router-dom';
import { Paper, Grid } from '@material-ui/core';
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateStockInward from "../StockInwards/CreateStockInward";


const todate = new Date();
// var fromdate = todate.getFullYear() + '/04/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);


const StockInward = () => {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [Count, setCount] = useState('');
    const [DocumentTypecmb, setDocumentTypecmb] = useState([]);
    const [SendFrom, setSendFrom] = useState('');
    const [DocumentType, setDocumentType] = useState('');
    const [TransactionStoreID, setTransactionStoreID] = useState('');
    const [TransactionStorecmb, setTransactionStorecmb] = useState([]);
    const [FromDate, setFromDate] = useState(fromdate.toISOString());
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [responseTransactionStore, fetchTransactionStoreData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const [InventoryDocumentID, setInventoryDocumentID] = useState('')
    const [DocumentNo, setDocumentNo] = useState('');


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const handleOpenModal = () => {
        setOpen(true);
        setInventoryDocumentID('');
    }

    const PopulateData = () => {
        //debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("SendFrom", SendFrom);
        bodyFormData.append("DocumentNo", DocumentNo);
        bodyFormData.append("TransactionStoreID", TransactionStoreID);
        bodyFormData.append("DocumentType", DocumentType);
        // fetchData("StockInward/StockInwardList", bodyFormData);
        fetchData("StockInward/StockInwardList", bodyFormData);
    };

    const GetComboData = () => {
        var bodyFormData = new FormData();
        fetchTransactionStoreData("StockInward/ComboData", bodyFormData);
    };



    useEffect(() => {
        if (responseTransactionStore !== undefined) {
            // debugger;
            // setLoading(false);
            if (responseTransactionStore["cmbStore"] !== undefined) {
                setTransactionStorecmb(responseTransactionStore["cmbStore"]);
            }
        }
    }, [responseTransactionStore]);



    useEffect(() => {
        setDocumentTypecmb([
            { id: "Opening Stock", title: "Opening Stock" },
            { id: "Received From Production", title: "Received From Production" },
            { id: "Stock Transfer In", title: "Stock Transfer In" },
            { id: "Return From Customer", title: "Return From Customer" },
        ]);
        PopulateData();
        GetComboData();
    }, [])

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/StockInwards/StockInwardView", state: { InventoryDocumentID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "DocumentNo",
                headerName: "Document No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,

            },
            {
                field: "DocumentDate",
                headerName: "Doc Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            {
                field: "DocumentType",
                headerName: "Document Type",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
                renderCell: (params) => (
                    <Tooltip title={params.row.DocumentType} >
                        <span className="table-cell-trucate">{params.row.DocumentType}</span>
                    </Tooltip>
                )
            },
            {
                field: "StoreName",
                headerName: "Store",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            {
                field: "AccountName",
                headerName: "From Customer",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ProductionSection",
                headerName: "Production Section",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "FromStore",
                headerName: "From Store",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            {
                field: "Remarks",
                headerName: "Remarks",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "CreatedBy",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "CreatedOn",
                headerName: "Created On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            // {
            //     field: "ModifiedBy",
            //     headerName: "Modified By",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 160,

            // },
            // {
            //     field: "ModifiedOn",
            //     headerName: "Modified On",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            //     valueFormatter: params =>
            //         moment(params?.value).format("DD/MM/YYYY"),
            // },
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]);



    useEffect(() => {
        PopulateData();
    }, [])

    /* if (viewPath) return (
      <Redirect to={{ pathname: viewPath, state: { AccountID: AccountID }  }} />
    ); */

    return (
        <div >
            <Grid container direction="row" style={{ marginTop: -10 }} >
                <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                    <div style={{ width: "200px", marginLeft: 17 }}>
                        <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => setFromDate(dateString)}
                            locale="en"
                            displayFormat="DD/MMM/YYYY"
                            className='my-react-component'
                            onClear={() => { onFromClear(); }}
                            showOnInputClick
                            maxDate={new Date()}
                            returnFormat="YYYY/MM/DD"
                            defaultValue={defaultfromDate}
                        />
                    </div>
                </Grid>
                <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                    <div style={{ width: "200px", marginLeft: 50 }}>
                        <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => setToDate(dateString)}
                            locale="en"
                            displayFormat="DD/MMM/YYYY"
                            className='my-react-component'
                            onClear={() => { onToClear(); }}
                            showOnInputClick
                            maxDate={new Date()}
                            returnFormat="YYYY/MM/DD"
                            defaultValue={defaultToDate}
                        />
                    </div>
                </Grid>

            </Grid>
            <Grid container direction="row" style={{ marginTop: 5 }}>
                <BiztranControls.Select
                    label="Doc Type"
                    id="DocType"
                    style={{ width: "200px", marginLeft: 10 }}
                    options={DocumentTypecmb}
                    onChange={(e) => setDocumentType(e.target.value)}
                    SelectProps={{
                        native: true,
                    }}
                />
                <BiztranControls.Input
                    label="Doc Number"
                    id="DocNumber"
                    style={{ width: "200px", marginLeft: 75 }}
                    onChange={(e) => setDocumentNo(e.target.value)}
                />
            </Grid>
            <Grid container direction="row" >
                <BiztranControls.Select
                    label="Transaction Store"
                    id="TransactionStore"
                    style={{ width: "200px", marginLeft: 10 }}
                    options={TransactionStorecmb}
                    onChange={(e) => setTransactionStoreID(e.target.value)}
                />
                <BiztranControls.Input
                    label="Send From"
                    id="SendFrom"
                    style={{ width: "200px", marginLeft: 75 }}
                    onChange={(e) => setSendFrom(e.target.value)}
                />
                <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: 7 }}>{Count}</label>
                <BiztranControls.Button
                    responsive="true"
                    text="Populate"
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
                <BiztranControls.Button
                    responsive="true"
                    text="Add New"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => {
                        handleOpenModal();
                    }}
                />

            </Grid>
            <BiztranControls.DataGrid
                headerHeight={34}
                rowHeight={25}
                rows={rows}
                columns={columns}
                checkboxSelection={false}
                // autoHeight={true}
                Height="400px"
                //Height="700px"
                Width="100%"
            />
            <ModalFrame
                title="Add/Edit Stock Inwards"
                maxWidth="sm"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <CreateStockInward
                    InventoryDocumentID={InventoryDocumentID}
                    setOpen={setOpen}
                    PopulateData={PopulateData}
                />
            </ModalFrame>
        </div>
    );
};

export default StockInward;
